module.exports = __webpack_public_path__ + "img/restart.6229718e.png";